<template>
  <div>
    <transition name="bounce">
      <button
        v-show="visible"
        class="bg-primary h-50 w-50 fixed right-16 sm:right-24 rounded-full flex justify-center items-center cursor-pointer z-40"
        :class="{
          'bottom-16 sm:bottom-24': isMobile,
          'bottom-88 sm:bottom-96': !isMobile,
        }"
        @click="scrollToTop"
      >
        <slot />
      </button>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      intervalId: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.scrollCheck);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.scrollCheck);
  },
  methods: {
    scrollToTop() {
      this.intervalId = window.setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 50);
      }, 10);
    },
    scrollCheck() {
      this.visible = window.scrollY > 150;
    },
  },
});
</script>

<style>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
